import { useMutation } from "@apollo/react-hooks";
import gql from 'graphql-tag';
import { updateCacheByType } from "../../graphql/GraphQlProvider";

interface CreditCardFee {
    id?: number;
    fee: string;
    type: number;
    type_id: number;
}

export interface UpsertStateCreditCardFeesInput {
    inputs: CreditCardFee[];
}

export const gqlCreditCardFee = `
    id,
    fee,
    type,
    type_id
`;

interface UpsertStateCreditCardFeeData {
    __typename?: string,
    upsertStateCreditCardFees: [CreditCardFee];
}

export const UPSERT_STATE_CREDIT_CARD_FEE_MUTATION = gql`
    mutation upsertStateCreditCardFees($inputs: [UpsertStateCreditCardFeesInput]!){
        upsertStateCreditCardFees(inputs: $inputs){
            ${gqlCreditCardFee}
        }
    }
`;

export const upsertStateCreditCardFees = () => useMutation<UpsertStateCreditCardFeeData, UpsertStateCreditCardFeesInput>(
    UPSERT_STATE_CREDIT_CARD_FEE_MUTATION,
    {
        update: updateCacheByType('CreditCardFee'),
    }
);

export default upsertStateCreditCardFees;
